var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: { "close-on-click-modal": false, visible: _vm.visible },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            "status-icon": "",
            "label-width": "120px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.inputFormSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "流程分类",
                        prop: "category",
                        rules: [
                          {
                            required: true,
                            message: "流程分类不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.inputForm.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "category", $$v)
                            },
                            expression: "inputForm.category",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("act_category"),
                          function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "流程文件",
                        prop: "file",
                        rules: [
                          {
                            required: true,
                            message: "流程文件不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "upload-demo",
                          attrs: {
                            limit: 1,
                            "on-change": _vm.handleChange,
                            action:
                              this.$http.BASE_URL +
                              "/app/rest/import-process-model",
                            "on-success": _vm.handleSuccess,
                            "on-error": _vm.handleError,
                            "before-upload": _vm.beforeUpload,
                            "auto-upload": false,
                            "show-file-list": true,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip",
                            },
                            [
                              _vm._v(
                                "只允许导入“zip、bar、bpmn、bpmn20.xml”格式文件！"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "noMoreClick", rawName: "v-noMoreClick" }],
              attrs: { type: "primary", icon: "el-icon-circle-check" },
              on: {
                click: function ($event) {
                  return _vm.inputFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }